import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOP_TemplatesSummary = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Module Summary"
      videos={[]} // No specific video links provided
      takeaways={[
        { text: "If the question is theoretical, it will likely be from the Standard Template Library (STL). Learn the concepts mentioned in the video." },
        { text: "If the question is coding-based, it will likely be from function templates or class templates. Learn the syntax and practice related questions." },
        { text: "Regardless of the topic, always learn a basic code example for better understanding." },
        { text: "In exams, write the expected output at the end of your code (even if the logic is incorrect) to maximize marks." },
      ]}
      questions={[]} // No specific previous questions provided
      exampleVideos={[]} // No example question videos provided
    />
);
}

export default OOP_TemplatesSummary;
